<template>
    <flex-element :element-type="elementType" class="f-inline-flex f-self-start">
        <textarea
            class="f-w-1/1"
            :name="inputName"
            :placeholder="placeholder"
            :required="required"
            :aria-label="ariaLabel"
            :aria-labelledby="ariaLabelledBy"
            @input="onInput"
            @invalid="onInvalidInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-textarea',
    mixins: [baseAtom],

    props: {
        inputName: {
            type: String,
            required: true,
        },

        placeholder: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inputValueNew: '', // don't remove, needed for the "set cookie" logic in o-form-container
        };
    },

    methods: {
        onInput(e) {
            e.target.setCustomValidity('');
            this.inputValueNew = e.target.value;
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessage);
        },
    },
};
</script>
